import { type MergedCoupon } from '@cart-services/types'
import { ApplicableProductScope } from '@hooks-api/types/dataModel/coupon'
import { Box } from '@pets-ui/Box/Box'
import { HStack } from '@pets-ui/HStack/HStack'
import { Text } from '@pets-ui/Text/Text'
import { colors } from '@pets-ui/tokens/colors.stylex'
import { VStack } from '@pets-ui/VStack/VStack'
import * as stylex from '@stylexjs/stylex'
import { StmCouponBadge } from './StmCouponBadge'

const styles = stylex.create({
  root: {
    borderRadius: 8,
    cursor: 'pointer',
    width: '100%',
  },
  selected: {
    boxShadow: '0 0 8px 0 rgba(255, 199, 0, 0.60)',
  },
})

interface CouponFilterItemProps {
  coupon: MergedCoupon
  isSelected: boolean
  onToggle: (couponId: number) => void
}

const formatEndTime = (endTime: string | null | undefined) => {
  if (!endTime) return null
  const date = new Date(endTime)
  const y = date.getFullYear()
  const m = String(date.getMonth() + 1).padStart(2, '0')
  const d = String(date.getDate()).padStart(2, '0')
  return `${y}/${m}/${d}`
}

export const CouponFilterItem = ({ coupon, isSelected, onToggle }: CouponFilterItemProps) => {
  const formattedEndTime = formatEndTime(coupon.end_time)
  const scope = coupon.criterion_groups[0]?.applicable_product_scope
  const scopeLabel = scope === ApplicableProductScope.ALL_PRODUCT ? '全館商品' : '指定商品'

  return (
    <HStack
      flexWrap="nowrap"
      borderRadius={8}
      borderColor={isSelected ? colors.red600 : colors.grey300}
      borderStyle="solid"
      borderWidth={1}
      rootStyle={[styles.root, isSelected && styles.selected]}
      onClick={() => onToggle(coupon.coupon_id)}
    >
      <StmCouponBadge criterionGroups={coupon.criterion_groups} />
      <VStack gap={1} flexGrow={1} justifyContent="center" py={2.5} px={3}>
        <Text bold variant="subtitle" lineClamp={2}>{coupon.display_name}</Text>
        {formattedEndTime && (
          <Text variant="caption" color="grey">
            使用期限：
            {formattedEndTime}
          </Text>
        )}
        <HStack>
          <Box backgroundColor={colors.red100} padding="2px 6px" borderRadius={4}>
            <Text noWrap color={colors.red600} variant="caption" fontSize="12px">
              {scopeLabel}
            </Text>
          </Box>
        </HStack>
      </VStack>
    </HStack>
  )
}
